// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__DS0RX","logo":"Navbar_logo__jA5Pb"};